export const registerServiceWorker = () => true;
